import { Avatar, Box, Button, Container, DialogActions, Link, List, ListItem, ListItemAvatar, ListItemText, Paper, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { renderIfElse } from "../../../../utils";
import { Trans, useTranslation } from "react-i18next";
import * as propTypes from 'prop-types';
import CryptoIcon from "../../../../assets/logo/crypto-white.svg";
import WireIcon from "../../../../assets/logo/wire-white.svg";
import WireIconBlue from "../../../../assets/logo/wire-blue.svg";
import CryptoIconBlue from "../../../../assets/logo/crypto-themed.svg";
import { useDispatch, useSelector } from "react-redux";
import { getCurrenciesData, getPockytConnectedBanks, getSerivceProvider } from "../../../../store/actions";
import AppScreenLoader from "../../../../components/AppScreenLoader";
import { paymentOptions } from "../../../../utils/constants";
import AppDialogHalfScreen from "../../../../components/AppDialogHalfScreen";
import {
    getFiatCounterLimit,
    logEvent
} from "../../../../store/api";
import { useRef } from "react";
import { EVENTS } from "../../../../utils/events";
export default function Step2({ payment, styles,
    handlePaymentMethod }) {
    const [openDisclaimer,
        setOpenDisclaimer] = React.useState(false);
    const dispatch = useDispatch();
    const fiatService = useSelector(({ dashboard }) => dashboard?.fiatService);
    const currencies = useSelector(({ currencies }) => currencies.currencies);
    const { t } = useTranslation();
    const eventRef = useRef(null);
    const [isFiatLimitReached, setFiatLimitReached] = React.useState({});
    useEffect(() => {
        getFiatLimitReached();
    }, [])
    const getFiatLimitReached = async () => {
        try {
            const data = await getFiatCounterLimit();
            if(data?.result?.error) {
                logEvent({
                    current: EVENTS.BANK_TRANSFER.BANK_POPUP_LIMIT_REACHED,
                    activity: EVENTS.BANK_TRANSFER.BANK_POPUP_LIMIT_REACHED,
                    meta: {}
                })
            }
            setFiatLimitReached(data?.result?.error);
        } catch (err) {
            console.log(err);
        }
    };
    useEffect(() => {
        dispatch(getCurrenciesData());
        dispatch(getSerivceProvider());
        dispatch(getPockytConnectedBanks());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (!currencies) {
        return <AppScreenLoader />;
    }
    const handlePaymentMethodAction = (ev) => {
        eventRef.current = ev;
        logEvent({
            current: EVENTS.BANK_TRANSFER.BANK_STEP_SELECTED,
            activity: EVENTS.BANK_TRANSFER.BANK_STEP_SELECTED,
            meta: {}
        })
        handleDisclaimerOpen()
    }
    const handleDisclaimerOpen = () => {
        logEvent({
            current: EVENTS.BANK_TRANSFER.BANK_POPUP_BETA,
            activity: EVENTS.BANK_TRANSFER.BANK_POPUP_BETA,
            meta: {}
        })
        setOpenDisclaimer(true);
    }
    const handleDisclaimerClose = (isFiatLimitReached) => {
        setOpenDisclaimer(false);
        logEvent({
            current: isFiatLimitReached ? EVENTS.BANK_TRANSFER.BANK_POPUP_LIMIT_REACHED_OK : EVENTS.BANK_TRANSFER.BANK_POPUP_BETA_CANCEL,
            activity: isFiatLimitReached ? EVENTS.BANK_TRANSFER.BANK_POPUP_LIMIT_REACHED_OK : EVENTS.BANK_TRANSFER.BANK_POPUP_BETA_CANCEL,
            meta: {}
        })
    };
    const handleContinueAction = () => {
        handlePaymentMethod(eventRef.current, paymentOptions[fiatService?.serviceName]);
        logEvent({
            current: EVENTS.BANK_TRANSFER.BANK_POPUP_BETA_CONTINUE,
            activity: EVENTS.BANK_TRANSFER.BANK_POPUP_BETA_CONTINUE,
            meta: {}
        })
    }
    function BankTransferDisclaimerModal() {
        const popupTextMapping = {
            title: isFiatLimitReached ? t("bank.limitReached.title") : t("bank.disclaimerTitle"),
            description1: isFiatLimitReached ? t("bank.limitReached.description") : t("bank.disclaimerDescription"),
        };
        return (
            <AppDialogHalfScreen
                show={openDisclaimer}
                onChangeShow={(val) => handleDisclaimerClose(val)}
                title={popupTextMapping.title}
                centralize={true}
            >
                <Box>
                    <Typography
                        color="#D4D4D8"
                        fontSize={14}
                        fontWeight={400}
                        marginTop={2}
                        fontFamily={"Manrope"}
                    >
                        <Trans
                            i18nKey={popupTextMapping.description1} />
                    </Typography>
                </Box>
                <DialogActions
                    sx={{
                        marginTop: 2,
                        display: "flex",
                        justifyContent: isFiatLimitReached ? "center" : "space-between",
                    }}
                >
                     {/* beta */}
                    {!isFiatLimitReached && (
                        <Button autoFocus onClick={() => handleDisclaimerClose(false)}
                            sx={{
                                color: "#F8FAFF",
                                textTransform: "capitalize"
                            }}
                        >
                            {t("Cancel")}
                        </Button>
                    )}
                    {/* limit reached */}
                    {isFiatLimitReached && (
                        <Button autoFocus onClick={() => handleDisclaimerClose(isFiatLimitReached)}
                            variant="contained"
                            color="primary"
                            sx={{
                                color: "#F8FAFF",
                                textTransform: "capitalize",
                                borderRadius: "8px",
                                ":disabled": { backgroundColor: "#0088F5", opacity: 0.4 },
                            }}
                        >
                            {t("close")}
                        </Button>
                    )}
                    {/* beta */}        
                    {!isFiatLimitReached && (<Button autoFocus onClick={() => handleContinueAction()}
                        variant="contained"
                        color="primary"
                        sx={{
                            color: "#F8FAFF",
                            textTransform: "capitalize",
                            borderRadius: "8px",
                            ":disabled": { backgroundColor: "#0088F5", opacity: 0.4 },
                        }}
                    >
                        {t("loginPage.continue")}
                    </Button>
                    )}
                </DialogActions>

            </AppDialogHalfScreen >
        );
    }
    return (<Paper
        sx={{
            backgroundColor: "transparent",
            boxShadow: "none",
            paddingTop: 1,
            width: "100%",
        }}
    >

        {(!currencies?.length && !fiatService?.enableFiat) && <Container maxWidth="md" disableGutters>
            <Typography variant="body2" fontSize={16} marginTop={5} textAlign={'left'}>
                {t('NoPaymentMethod')} <Link href="mailto:support@rocketfuel.inc" target="_blank" color={"#0088F5"}>support@rocketfuel.inc</Link>
            </Typography>
        </Container>}
        <List>
            {!!currencies?.length && <ListItem
                style={payment === paymentOptions.crypto ? styles.selected : {}}
                onClick={(ev) => handlePaymentMethod(ev, paymentOptions.crypto)}
            >
                <ListItemAvatar>
                    <Avatar>
                        {renderIfElse(
                            payment === "crypto",
                            <CryptoIconBlue />,
                            <CryptoIcon />
                        )}
                    </Avatar>
                </ListItemAvatar>
                <ListItemText primary={t('crypto.transfer')} secondary={t('crypto.transfer.duration')} />
            </ListItem>}
            {!!fiatService?.enableFiat && <ListItem
                style={[paymentOptions.masspay, paymentOptions.pockyt].includes(payment) ? styles.selected : {}}
                onClick={handlePaymentMethodAction}>
                <ListItemAvatar>
                    <Avatar>
                        {renderIfElse(
                            payment === "non-crypto",
                            <WireIconBlue />,
                            <WireIcon />
                        )}

                    </Avatar>
                </ListItemAvatar>
                <ListItemText
                    primary={t('bank.transfer')}
                // secondary={t('bank.transfer.duration')}
                />

            </ListItem>}
        </List>
        <BankTransferDisclaimerModal />
    </Paper>)
}

Step2.propTypes = {
    payment: propTypes.any,
    paymentOptions: propTypes.any,
    styles: propTypes.any,
    handlePaymentMethod: propTypes.any
}